import { useLiveQuery } from 'dexie-react-hooks';

import { logbookEntries } from '@/lib/db';

/** How many entries are still drafts — `null` while the database opens. */
export function useDraftCount(): number | null {
  return useLiveQuery(
    async () => (await logbookEntries.listOrdered()).filter((entry) => entry.isDraft).length,
    [],
    null,
  );
}
